<template>
  <div class="invoice-modal">
    <sweet-modal ref="modal" @close="$emit('close')">
    <div class="order-list-container">
      <admin-filter
        :items="filterData"
        :itemFiltered.sync="filtered"
        @getData="getDataFromServer"
      ></admin-filter>

      <order-table :field_list="tableData"
                   :items="tableItems"
                   :filtered="filtered"
                   :allCount="allCount"
                   :filteredCount="filteredCount"
                   @check="clickCheckBox"
                   :table_width="1300"
                   @getData="getDataFromServer"
                   @ordering="ordering"
                   @selPageLength="selPageLength">
        <td slot="check" slot-scope="props">
          <lp-check-bool
            v-if="checkArr[props.idx]!==undefined" @onCheck="onCheck(props.idx)"
            :checkedVal="checkArr[props.idx].value"></lp-check-bool>
        </td>
        <td slot="created_time" slot-scope="props">{{ props.item.created_time }}</td>
        <td slot="order_type_kor" slot-scope="props">{{ props.item.order_type_kor }}</td>
        <td slot="reference_no" slot-scope="props">{{ props.item.reference_no }}</td>
        <td slot="user_name" slot-scope="props">{{props.item.user.last_name }}{{ props.item.user.name }}</td>
        <td slot="email" slot-scope="props">{{props.item.user.email }}</td>
        <td slot="point" slot-scope="props">{{props.item.point|currencyNum }}</td>
        <td slot="invoice_num" slot-scope="props">{{ props.item.invoice ? props.item.invoice.invoice_number : '-' }}</td>
        <td slot="invoice_price" slot-scope="props">{{ props.item.invoice ? currencyNum(props.item.invoice.price) : '-' }}</td>
        <td slot="invoice_price_won" slot-scope="props">{{ props.item.invoice ? currencyNum(props.item.invoice.price_won) : '-' }}</td>
      </order-table>
      <div class="flex-end">
        <button class="button is-primary" @click="clickAccept">선택</button>
      </div>
    </div>
  </sweet-modal>
  </div>
</template>

<script>
  import ShipAgencyMixin from "../../../mixins/ShipAgencyMixin";
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {
    name: "InvoiceModal",
    mixins: [
      ShipAgencyMixin
    ],
    components: {
      LpCheckBool
    },
    created() {
      this.init();
    },
    mounted() {
      this.$nextTick(()=>{
        this.$refs.modal.open();
      });
    },
    data() {
      return {

      }
    },
    methods: {
      init() {
        this.initializing('ship_agency_invoice', `shipagency/order?invoice=false&status=101`)
      },
      getDataFromServer() {
        this.getData();
      },
      onCheck(idx) {
        this.checkArr.forEach((item, i) => {
          item.value = i === idx;
        });
      },
      clickAccept() {
        let invoice = this.tableItems.find(i => i.id === this.checkArr.find(i => i.value).id).invoice.id;
        this.$emit('select', invoice);
        this.$refs.modal.close();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .order-list-container
    font-size 14px
  .btn-download
    width fit-content
    display flex
    align-items center
    gap 8px
</style>
<style lang="stylus">

</style>
